import { isNumberWithinRange } from "src/utils/validators";
import { QuizQuestion } from "./QuizQuestionModel";

export class QuizQuestionAnswer {
    question: QuizQuestion;
    correctAnswerIndex: number;
    userAnswerIndex: number;
    isCorrect: boolean;

    constructor(
        question: QuizQuestion,
        correctAnswerIndex: number,
        userAnswerIndex: number,
    ) {
        if (!isNumberWithinRange(correctAnswerIndex, 0, question.options.length)
            || !isNumberWithinRange(userAnswerIndex, 0, question.options.length)) {
            throw new Error("Answer indexes must be within range of questions");
        }

        this.question = question;
        this.correctAnswerIndex = correctAnswerIndex;
        this.userAnswerIndex = userAnswerIndex;
        this.isCorrect = correctAnswerIndex === userAnswerIndex;
    }

    getUserAnswer() {
        return this.question.options[this.userAnswerIndex];
    }

    getCorrectAnswer() {
        return this.question.options[this.correctAnswerIndex];
    }
}
